import { motion } from "framer-motion";
import {
  Layers,
  Users,
  ShieldCheck,
  Globe2,
  Sparkles,
  Handshake,
} from "lucide-react";
import { WHY_ITEMS } from "@/lib/eraContent";
import { useLang } from "@/lib/LanguageContext";

const ICON_MAP = { Layers, Users, ShieldCheck, Globe2, Sparkles, Handshake };

export const WhyERA = () => {
  const { t } = useLang();

  return (
    <section
      id="why-era"
      data-testid="why-era-section"
      className="relative py-24 md:py-32 bg-navy-50/40"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-xs uppercase tracking-[0.28em] font-semibold text-navy-900">
            {t.why.eyebrow}
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-navy-900 leading-[1.08]">
            {t.why.title}
            <br />
            <span className="text-gold-600">{t.why.titleAccent}</span>
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {WHY_ITEMS.map((item, i) => {
            const Icon = ICON_MAP[item.icon] || Sparkles;
            const highlighted = i === 0 || i === 4;
            const copy = t.why.items[item.key];
            return (
              <motion.div
                key={item.key}
                data-testid={`why-card-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className={
                  "group rounded-3xl p-8 md:p-10 border transition-all duration-300 hover:-translate-y-1 " +
                  (highlighted
                    ? "bg-navy-900 text-white border-navy-800 hover:shadow-[0_28px_60px_-20px_rgba(13,27,62,0.55)]"
                    : "bg-white text-navy-900 border-navy-100 hover:border-navy-200 hover:shadow-[0_20px_40px_-20px_rgba(13,27,62,0.15)]")
                }
              >
                <div
                  className={
                    "h-14 w-14 rounded-2xl flex items-center justify-center transition-transform group-hover:-rotate-6 " +
                    (highlighted
                      ? "bg-gold text-navy-900"
                      : "bg-navy-50 text-navy-900")
                  }
                >
                  <Icon className="w-6 h-6" />
                </div>
                <h3
                  className={
                    "mt-8 font-display text-xl md:text-2xl font-semibold tracking-tight " +
                    (highlighted ? "text-white" : "text-navy-900")
                  }
                >
                  {copy.title}
                </h3>
                <p
                  className={
                    "mt-3 leading-relaxed text-sm " +
                    (highlighted ? "text-slate-300" : "text-navy-700/70")
                  }
                >
                  {copy.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
